exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "deployment-list md-card{width:98%}deployment-list .truncated{max-width:150px}deployment-list table.md-table:not(.md-row-select) td.md-cell:nth-child(n+2):nth-last-child(n+2),deployment-list table.md-table:not(.md-row-select) th.md-column:nth-child(n+2):nth-last-child(n+2){padding:0 16px 0 0}deployment-list md-select.md-table-select>.md-select-value>span>.md-text{display:inline-block!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./sources/components/deployments/deployment-list/deployment-list.scss
// module id = 490
// module chunks = 0